import { Avatar, Box, Stack, Typography } from "@mui/material";
import moment from "moment";
import { getFirstAndLastLetters } from "src/utils";

const MainInfo = ({
  mainInfo,
}: {
  mainInfo: {
    agreementTypeLabel: string; //"Revenue Sharing" | "Renting"
    startDate: string;
    endDate: string;
    nameAr: string;
    nameEn: string;
  };
}) => {
  const { agreementTypeLabel, startDate, endDate, nameAr, nameEn } = mainInfo;

  return (
    <Stack spacing={3} height={"100%"}>
      <Stack
        direction={"row"}
        spacing={"11px"}
        display={"flex"}
        alignItems={"center"}
      >
        <Avatar
          sx={{
            background: "linear-gradient(180deg, #656464 0%, #373737 100%)",
            width: "60px",
            height: "60px",
            color: "#FFFFFF",
            fontSize: "22px",
            fontWeight: 600,
            lineHeight: "22px",
            textTransform: "uppercase",
          }}
        >
          {getFirstAndLastLetters(nameEn)}
        </Avatar>
        <Box>
          <Typography
            fontSize={"14px"}
            fontWeight={600}
            lineHeight={"16px"}
            color={"#FFFFFF"}
            mb={"5px"}
          >
            {nameEn}
          </Typography>
          <Typography
            fontSize={"14px"}
            fontWeight={600}
            lineHeight={"16px"}
            color={"#ACA8A8"}
          >
            {agreementTypeLabel} Agreement Type
          </Typography>
        </Box>
      </Stack>

      {/* divider */}
      <Box bgcolor={"#454343"} width={"100%"} height={"1px"} />

      <Stack spacing={"5px"}>
        <Typography
          fontSize={"14px"}
          lineHeight={"16px"}
          fontWeight={600}
          color={"#FFFFFF"}
        >
          Name in Arabic
        </Typography>
        <Typography
          fontSize={"14px"}
          lineHeight={"16px"}
          fontWeight={600}
          color={"#ACA8A8"}
        >
          {nameAr}
        </Typography>
      </Stack>
      <Stack spacing={"5px"}>
        <Typography
          fontSize={"14px"}
          lineHeight={"16px"}
          fontWeight={600}
          color={"#FFFFFF"}
        >
          Start Date
        </Typography>
        <Typography
          fontSize={"14px"}
          lineHeight={"16px"}
          fontWeight={600}
          color={"#ACA8A8"}
        >
          {startDate ? moment(Number(startDate)).format("DD/MM/yyyy") : "--"}
        </Typography>
      </Stack>
      <Stack spacing={"5px"}>
        <Typography
          fontSize={"14px"}
          lineHeight={"16px"}
          fontWeight={600}
          color={"#FFFFFF"}
        >
          End Date
        </Typography>
        <Typography
          fontSize={"14px"}
          lineHeight={"16px"}
          fontWeight={600}
          color={"#ACA8A8"}
        >
          {endDate ? moment(Number(endDate)).format("DD/MM/yyyy") : "--"}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default MainInfo;
